export default "//cdn.scentbird.com/assets/frontbird-site/images/spices_9b1a03.jpg";